export const usePSLIFeatureFlagLimit = () => {
  return 35;
};
